var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
// tslint:disable-next-line: max-line-length
import { MatTableDataSource, MatDialog } from '@angular/material';
import { HttpClient } from "@angular/common/http";
import { SelectionModel } from '@angular/cdk/collections';
import { environment } from "environments/environment";
import { DatePipe, formatCurrency, getCurrencySymbol } from '@angular/common';
import * as XLSX from 'xlsx';
//snackbar 1
import { MatSnackBar } from '@angular/material';
import { NavbarComponent } from '../../shared/navbar/navbar.component';
import { GlobalService } from '../../../services/global.service';
var ELEMENT_DATA = [];
var CargaComponent = /** @class */ (function () {
    function CargaComponent(http, dialog, datePipe, snackBar, globalService) {
        this.http = http;
        this.dialog = dialog;
        this.datePipe = datePipe;
        this.snackBar = snackBar;
        this.globalService = globalService;
        // tslint:disable-next-line: no-inferrable-types
        this.modaless = 'modal-body';
        this.displayedColumns = ['select', 'id', 'cuit', 'empresa', 'fecha', 'importe', 'periodo', 'estado', 'comentario', 'boton'];
        this.dataSourceOpe = new MatTableDataSource(ELEMENT_DATA);
        this.selection = new SelectionModel(true, []);
        this.permiteEdicion = false;
        this.loadingmodif = false;
        this.loadingUpdate = false;
        this.obse = false;
        this.status = false;
        this.item = [{}];
        this.modalessHeader = 'modal-header';
        this.pedro = false;
        // tslint:disable-next-line: member-ordering
        this.loadingPedro = false;
        this.loadingNuevaNovedad = false;
        this.loadingHistorico = false;
        this.loading = false;
        this.loadingins = false;
        this.fecha_hoy = new Date;
        this.fecha_hoy = this.datePipe.transform(this.fecha_hoy, "yyyy-MM-dd");
        this.fechaparaInsert = this.fecha_hoy;
        //this.fechah = this.fecha_hoy;
        this.filtroCuit = 'TODOS';
        this.filtroEstado = 'TODOS';
        this.pfecha = this.fecha_hoy;
        this.role = localStorage.getItem('role');
        this.userlog = localStorage.getItem('userId');
        console.log("ROLE: " + this.role);
        console.log("USERLOG: " + this.userlog);
    }
    CargaComponent.prototype.obtenerNoti = function (evento) {
        console.log('noti obtenida', evento);
    };
    CargaComponent.prototype.applyFilter = function (event) {
        var filterValue = event.target.value;
        this.dataSourceOpe.filter = filterValue.trim().toLowerCase();
    };
    CargaComponent.prototype.obtenerNotiGlobal = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // this.coco = await this.globalService.cargarNotis();
                    // console.log('coco=', this.coco);
                    return [4 /*yield*/, this.globalService.cargarNotis().then(function (lala) {
                            console.log(lala);
                        })];
                    case 1:
                        // this.coco = await this.globalService.cargarNotis();
                        // console.log('coco=', this.coco);
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CargaComponent.prototype.addCommas = function (nStr) {
        nStr += '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        return x1 + x2;
    };
    CargaComponent.prototype.updateValue = function (value) {
        var val = parseInt(value, 10);
        if (Number.isNaN(val)) {
            val = 0;
        }
        //  console.log(formatCurrency(val, 'en-US', getCurrencySymbol('USD', 'wide')));
        var resp = (formatCurrency(val, 'en-US', getCurrencySymbol('USD', 'wide')).replace('$', ''));
        return resp;
    };
    CargaComponent.prototype.exportExcel2 = function (data) {
        var arreglo = [];
        for (var _i = 0; _i < data.length; _i++) {
            if (data[_i]['estado'] === 'DEUDA') {
                var number = data[_i]['importe'];
                arreglo.push({
                    ID: data[_i]['id'],
                    CUIT: data[_i]['cuit'],
                    RAZON_SOCIAL: data[_i]['empresa'],
                    PERIODO: data[_i]['periodo'],
                    DEUDA: parseFloat(number)
                });
            }
        }
        console.log(arreglo);
        var worksheet = XLSX.utils.json_to_sheet(arreglo);
        var workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        XLSX.writeFile(workbook, "DeudaSIDEU_" + this.fechad + "_al_" + this.fechah + ".xls", { bookType: 'xls', type: 'buffer' });
    };
    CargaComponent.prototype.removeAt = function (n) {
        //console.log("borrando: " + n);
        this.itemElim = n;
    };
    CargaComponent.prototype.permitirEdicion = function () {
        this.permiteEdicion = !this.permiteEdicion;
        console.log(this.permiteEdicion);
    };
    CargaComponent.prototype.updateNovedad = function () {
        var _this = this;
        this.loadingUpdate = true;
        //http://localhost:1337/api/nuevaope/updateOp
        var body = {
            "id": parseInt(this.modifid),
            "cui": this.modifcuit,
            "fec": this.modiffec,
            "imp": this.modifimporte,
            "per": this.modifperiodo,
            "obs": this.modifobs,
            "est": this.modifestado
        };
        console.log(body);
        this.loadingUpdate = true;
        this.http.post(environment.backendUrl + "/api/nuevaope/updateOp", body)
            .subscribe(function (res) { return console.log('---RES OK', res); }, function (status) {
            if (status.status == 200) {
                //console.warn("modificado OK!");   
                _this.loadingUpdate = false;
                //document.getElementById("salirmodal").click();
                _this.snackBar.open("modificado!", 'Cerrar', { duration: 5000 });
                //this.cargarGrid();
                _this.calculaHistorico(_this.modifcuit);
                _this.cargarGrid();
                console.log("modifica ok");
                //document.getElementById("salirmodal").click();
            }
            else {
                //console.warn("ERROR POST!");
                //console.log(JSON.stringify(status["error"]["code"]));
                _this.snackBar.open("FALLO! " + JSON.stringify(status["error"]["code"]), 'Cerrar', { duration: 5000 });
                console.log("fallo modificacion");
                _this.loadingUpdate = false;
            }
        });
    };
    CargaComponent.prototype.borrarNovedad = function (i) {
        var _this = this;
        this.itemElim = i;
        //http://localhost:1337/api/nuevaope/borrar
        var body = { "i": i };
        this.loadingborrar = true;
        this.http.post(environment.backendUrl + "/api/nuevaope/borrar", body)
            .subscribe(function (res) { return console.log('---RES OK', res); }, function (status) {
            if (status.status == 200) {
                //console.warn("borrado OK!");   
                _this.loadingborrar = false;
                document.getElementById("salirmodal").click();
                _this.snackBar.open("ELIMINADO!", 'Cerrar', { duration: 5000 });
                _this.cargarGrid();
            }
            if (status.status == 500) {
                // console.warn("ERROR POST!");
                // console.log(JSON.stringify(status["error"]["code"]));
                _this.snackBar.open("FALLO! " + JSON.stringify(status["error"]["code"]), 'Cerrar', { duration: 5000 });
                _this.loadingborrar = false;
            }
        });
    };
    CargaComponent.prototype.ngOnInit = function () {
        console.log(this.fecha_hoy);
        this.fechad = '2010-01-01';
        this.fechah = this.fecha_hoy;
        this.calculaEmpresas();
        //this.cargarGrid();
    };
    CargaComponent.prototype.habilitaobs = function () {
        if (this.obse == false) {
            this.obse = true;
        }
        else {
            this.obse = false;
        }
    };
    CargaComponent.prototype.habilitaestado = function () {
        if (this.status == false) {
            this.status = true;
        }
        else {
            this.status = false;
        }
    };
    CargaComponent.prototype.ngDoCheck = function () {
        if (this.selection.selected[0] != null && this.selection.selected[0] != undefined) {
            this.item = [];
            this.item.push(this.selection.selected[0]);
            //console.log(this.selection.selected[0]["id"]);
            console.log(this.item);
            this.modifobs = this.item[0]["obs"];
            this.modifestado = this.item[0]["estado"];
            this.modifimporte = this.item[0]["importe"];
            this.modifperiodo = this.item[0]["periodo"];
            this.modifid = this.item[0]["id"];
            this.modifcuit = this.item[0]["cuit"];
            this.modiffec = this.item[0]["fecha"];
            var body = {
                "id": this.modifid,
                "cui": this.modifcuit,
                "fec": this.modiffec,
                "imp": this.modifimporte,
                "per": this.modifperiodo,
                "obs": this.modifobs,
                "est": this.modifestado
            };
            //console.log(body);
        }
        else {
            //console.log("no se selecciono nada");
        }
        //console.log(this.filtroCuit + '-' + this.filtroEstado + '-' + this.fechad + '-'+this.fechah);
        //estilo css segun estado deuda::
        if (this.item[0]["estado"] == 'DEUDA') {
            this.modalessBody = 'modal-body rojin';
            this.modalessHeader = 'modal-header rojin';
        }
        else {
            this.modalessBody = 'modal-body';
            this.modalessHeader = 'modal-header';
        }
    };
    CargaComponent.prototype.habilitaPedro = function () {
        if (this.userlog == 'juanpedroverellen' || this.userlog == 'matiasmasciotta') {
            if (this.pedro == false) {
                this.pedro = true;
            }
            else {
                this.pedro = false;
            }
            // console.log("HABILITANDO APEDRO");
        }
    };
    CargaComponent.prototype.actualizarComentario = function (i) {
        var _this = this;
        this.loadingPedro = true;
        var body = {
            'id': i,
            'comen': this.comentarioPedro
        };
        // http://localhost:1337/api/nuevaope/updateComentario
        this.http.post(environment.backendUrl + "/api/nuevaope/updateComentario", body)
            .subscribe(function (res) { return console.log('---RES OK', res); }, function (status) {
            if (status.status === 200) {
                // console.warn("coment post OK!");
                _this.loadingPedro = false;
                _this.snackBar.open("Comentario a\u00F1adido a " + _this.item[0]['empresa'] + "!", 'Cerrar', { duration: 7000 });
                _this.globalService.cargarNotis();
                _this.cargarGrid();
            }
            if (status.status === 500) {
                // console.warn("ERROR POST!");
                // console.log(JSON.stringify(status["error"]["code"]));
                _this.snackBar.open("FALLO! " + JSON.stringify(status['error']['code']), 'Cerrar', { duration: 7000 });
                _this.loadingPedro = false;
            }
            else {
                _this.loadingPedro = false;
            }
        });
    };
    CargaComponent.prototype.clean = function () {
        this.selection.clear();
    };
    CargaComponent.prototype.cargarGrid = function () {
        var _this = this;
        this.loading = true;
        this.dataSourceOpe.data = null;
        //http://localhost:1337/api/nuevaope/consulta?cuit=TODOS&fecd=2015-01-01&fech=2021-01-01&esta=TODOS
        this.http.get(environment.backendUrl + "/api/nuevaope/consulta?cuit=" + this.filtroCuit + "&fecd=" + this.fechad + "&fech=" + this.fechah + "&esta=" + this.filtroEstado)
            .subscribe(function (datos) {
            if (datos) {
                _this.dataSourceOpe.data = datos[0];
                //console.log(this.dataSourceOpe.data);
                _this.totregistros = _this.dataSourceOpe.data.length;
            }
            else {
                //console.warn("NO HAY");
            }
            ;
            _this.loading = false;
        });
    };
    CargaComponent.prototype.insertarNovedad2 = function () {
        var _this = this;
        this.loadingNuevaNovedad = true;
        if (this.modifimporte == '' || this.modifimporte == null) {
            this.modifimporte = '0';
        }
        var body = {
            "cui": "" + this.modifcuit,
            "fec": "" + this.fechaparaInsert,
            "imp": "" + this.modifimporte,
            "per": "" + this.modifperiodo,
            "obs": "" + this.modifobs,
            "est": "" + this.modifestado
        };
        //console.log("$$insertando desde edit----------->");
        // console.warn(body);
        //http://localhost:1337/api/nuevaope/insert
        this.http.post(environment.backendUrl + "/api/nuevaope/insert", body)
            .subscribe(function (res) { return console.log('---RES OK', res); }, function (status) {
            if (status.status == 200) {
                // console.warn("post OK!");   
                _this.loadingNuevaNovedad = false;
                _this.snackBar.open("Nueva nodedad insertada para " + _this.item[0]["empresa"] + "!", 'Cerrar', { duration: 5000 });
                _this.cargarGrid();
                document.getElementById("salirmodal").click();
            }
            if (status.status == 500) {
                //console.warn("ERROR POST!");
                //console.log(JSON.stringify(status["error"]["code"]));
                _this.snackBar.open("FALLO! " + JSON.stringify(status["error"]["code"]), 'Cerrar', { duration: 5000 });
                _this.loadingNuevaNovedad = false;
            }
            else {
                _this.loadingNuevaNovedad = false;
            }
        });
    };
    CargaComponent.prototype.insertaNuevo = function () {
        var _this = this;
        this.loadingins = true;
        if (this.pimporte == '' || this.pimporte == null) {
            this.pimporte = '0';
        }
        var body = {
            "cui": "" + this.pcuit,
            "fec": "" + this.pfecha,
            "imp": "" + this.pimporte,
            "per": "" + this.pperiodo,
            "obs": "" + this.pobs,
            "est": "" + this.pestado
        };
        //http://localhost:1337/api/nuevaope/insert
        this.http.post(environment.backendUrl + "/api/nuevaope/insert", body)
            .subscribe(function (res) { return console.log('---RES OK', res); }, function (status) {
            if (status.status == 200) {
                //console.warn("post OK!");   
                _this.snackBar.open("Insertado OK!", 'Cerrar', { duration: 5000 });
                _this.loadingins = false;
                _this.cargarGrid();
            }
            if (status.status == 500) {
                //console.warn("ERROR POST!");
                //console.log(JSON.stringify(status["error"]["code"]));
                _this.snackBar.open("FALLO! " + JSON.stringify(status["error"]["code"]), 'Cerrar', { duration: 5000 });
                _this.loadingins = false;
            }
        });
    };
    CargaComponent.prototype.calculaEmpresas = function () {
        var _this = this;
        this.loadingemp = true;
        //http://localhost:1337/api/nuevaope/calculaemp
        this.http.get(environment.backendUrl + "/api/nuevaope/calculaemp")
            .subscribe(function (datos) {
            if (datos) {
                _this.dataSourceEmpresas = datos[0];
                //console.log(this.dataSourceEmpresas);
            }
            else {
                //console.warn("NO HAY");
            }
            ;
            _this.loadingemp = false;
        });
    };
    CargaComponent.prototype.calculaHistorico = function (cuit) {
        var _this = this;
        this.loadingHistorico = true;
        //http://localhost:1337/api/nuevaope/calculahistorico?cui=30601290800
        this.http.get(environment.backendUrl + "/api/nuevaope/calculahistorico?cui=" + cuit)
            .subscribe(function (datos) {
            if (datos) {
                _this.dataSourceHistorico = datos;
                _this.modiffec = _this.datePipe.transform(_this.dataSourceHistorico[0]['fecha'], "yyyy-MM-dd");
                console.log(_this.modiffec);
                //console.log(this.dataSourceHistorico);
                _this.loadingHistorico = false;
            }
            else {
                //console.warn("NO HAY");
                _this.loadingHistorico = false;
            }
            ;
        });
    };
    /** Whether the number of selected elements matches the total number of rows. */
    CargaComponent.prototype.isAllSelected = function () {
        var numSelected = this.selection.selected.length;
        var numRows = this.dataSourceOpe.data.length;
        return numSelected === numRows;
    };
    /** Selects all rows if they are not all selected; otherwise clear selection. */
    CargaComponent.prototype.masterToggle = function () {
        var _this = this;
        this.isAllSelected() ?
            this.selection.clear() :
            this.dataSourceOpe.data.forEach(function (row) { return _this.selection.select(row); });
    };
    /** The label for the checkbox on the passed row */
    CargaComponent.prototype.checkboxLabel = function (row) {
        this.clean();
        if (!row) {
            return (this.isAllSelected() ? 'select' : 'deselect') + " all";
        }
        return (this.selection.isSelected(row) ? 'deselect' : 'select') + " row " + (row.id + 1);
    };
    return CargaComponent;
}());
export { CargaComponent };
